import * as Yup from "yup";

export const registerSchema1 = Yup.object().shape({
  schoolName: Yup.string().required("اسم المدرسة مطلوب"),
  country: Yup.string().required("المنطقه مطلوبه"),
  city: Yup.string().required("المدينه مطلوبه"),
  schoolYear: Yup.string().required("الصف الدراسي مطلوب"),
  // educationType: Yup.string().required("الشعبه مطلوبه"),
  secondLanguage: Yup.string().required("اللغة الثانية مطلوبه"),
  schoolType: Yup.string().required("نوع المدرسة مطلوبه"),
});
export const registerSchema2 = Yup.object().shape({
  fullName: Yup.string()
    .test("wordCount", "الاسم يجب ان يحتوي على 4 اسماء", (value) => {
      if (!value) {
        return false; // Return false if the value is empty
      }
      const words = value.trim().split(/\s+/); // Split the value into words
      return words.length === 4; // Return true if the number of words is exactly three
    })
    .required("الاسم مطلوب"),
  gender: Yup.string().required("الجنس مطلوب"),
  fatherJob: Yup.string().required("الوظيفة مطلوبه"),
  fatherPhone: Yup.string()
    .matches(/^\d{11}$/, "رقم الهاتف يجب ان يتكون من 11 رقم")
    .length(11)
    .required("رقم ولي الامر مطلوب"),
  nationalId: Yup.string()
    .matches(/^\d{14}$/, "الرقم القومي يجب ان يتكون من 14 رقم")
    .required("الرقم القومي مطلوب"),
  // nationalFront: Yup.mixed()
  //   .test(
  //     "fileSize",
  //     " حجم الصوره كبير ",
  //     (value: any) => value && value.size <= 2000000
  //   )
  //   .test(
  //     "fileType",
  //     " الصيغ المسموحه هي : .jpeg, .jpg, .png",
  //     (value: any) =>
  //       value && ["image/jpeg", "image/jpg", "image/png"].includes(value.type)
  //   )
  //   .required("صوره وش البطاقه مطلوبه"),
  // nationalBack: Yup.mixed()
  //   .test(
  //     "fileSize",
  //     " حجم الصوره كبير ",
  //     (value: any) => value && value.size <= 2000000
  //   )
  //   .test(
  //     "fileType",
  //     " الصيغ المسموحه هي : .jpeg, .jpg, .png",
  //     (value: any) =>
  //       value && ["image/jpeg", "image/jpg", "image/png"].includes(value.type)
  //   )
  //   .required("صوره ظهر البطاقه مطلوبه"),
});
export const registerSchema3 = Yup.object().shape({
  profileImage: Yup.mixed()
    .test(
      "fileSize",
      " حجم الصوره كبير ",
      (value: any) => value && value.size <= 2000000
    )
    .test(
      "fileType",
      " الصيغ المسموحه هي : .jpeg, .jpg, .png",
      (value: any) =>
        value && ["image/jpeg", "image/jpg", "image/png"].includes(value.type)
    )
    .required("صوره البروفايل مطلوبه"),
  phone: Yup.string()
    .matches(/^\d{11}$/, "رقم الهاتف يجب ان يتكون من 11 رقم")
    .length(11)
    .required("رقم الهاتف مطلوب"),
  userName: Yup.string()
    .matches(
      /^[A-Za-z0-9_]+$/,
      "يجب أن يحتوي الاسم على الحروف الإنجليزية فقط أو أرقام أو _"
    )
    .min(5, "الاسم يجب أن يكون على الأقل 5 حروف")
    .required("اسم المستخدم مطلوب"),
  email: Yup.string()
    .email("البريد الالكتروني غير صحيح")
    .required("البريد الالكتروني مطلوب"),
  password: Yup.string()
    .required("كلمة المرور مطلوبه")
    .min(8, "كلمة المرور يجب ان تكون على الاقل 8 حروف"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), undefined], " كلمه المرور غير متطابقه")
    .required("تاكيد كلمة المرور مطلوبه"),
});

export const registerSchema4 = Yup.object({
  code: Yup.mixed()
    .test(
      "is-valid-code",
      "Code must be a string or a number",
      (value) => typeof value === "string" || typeof value === "number"
    )
    .required("Code is required"),
});

// export const registerSchema = Yup.object().shape({
//   schoolName: Yup.string().required("اسم المدرسة مطلوب"),
//   country: Yup.string().required("المنطقه مطلوبه"),
//   city: Yup.string().required("المدينه مطلوبه"),
//   schoolYear: Yup.string().required("الصف الدراسي مطلوب"),
//   educationType: Yup.string().required("الشعبه مطلوبه"),
//   secondLanguage: Yup.string().required("اللغة الثانية مطلوبه"),
//   schoolType: Yup.string().required("نوع المدرسة مطلوبه"),
//   fullName: Yup.string().required("الاسم مطلوب"),
//   gender: Yup.string().required("الجنس مطلوب"),
//   fatherJob: Yup.string().required("الوظيفة مطلوبه"),
//   fatherPhone: Yup.string().required("رقم ولي الامر مطلوب"),
//   nationalId: Yup.string()
//     .matches(/^\d{14}$/, "الرقم القومي يجب ان يتكون من 14 رقم")
//     .required("الرقم القومي مطلوب"),
//   nationalFront: Yup.object().required("صوره وش البطاقه مطلوبه"),
//   nationalBack: Yup.object().required("صوره ظهر البطاقه مطلوبه"),
//   profileImage: Yup.object().required("صوره البروفايل مطلوبه"),
//   phone: Yup.string().required("رقم الهاتف مطلوب"),
//   userName: Yup.string().required("اسم المستخدم مطلوب"),
//   email: Yup.string()
//     .email("البريد الالكتروني غير صحيح")
//     .required("البريد الالكتروني مطلوب"),
//   password: Yup.string().required("كلمة المرور مطلوبه"),
//   confirmPassword: Yup.string().required("تاكيد كلمة المرور مطلوبه"),
// });
